import { render, staticRenderFns } from "./LoadInfoDisplay.vue?vue&type=template&id=35be0dc3&"
import script from "./LoadInfoDisplay.vue?vue&type=script&lang=js&"
export * from "./LoadInfoDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports